import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/auth/Login'
import Admin from '../views/Admin'

Vue.use(VueRouter)

const routes = [
			{
				path: '/login',
				name: 'login',
				component: Login
			},
			{
			path: '/admin',
			name: 'admin',
			component: Admin,
			children: [
			{
				path: '/dashboard',
				name: 'dashboard',
				component: () => import('../views/Dashboard'),
			},
			{
				path: '/agent-dashboard',
				name: 'agent-dashboard',
				component: () => import('../views/AgentDashboard'),
			},
			//Agent
			{
				path: '/agent-list',
				name: 'agent-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/agent/agentList'),
			},
			{
				path: '/agent-create',
				name: 'agent-create',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/agent/agentCreate'),
			},
			{
				path: '/agent-edit',
				name: 'agent-edit',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/agent/agentEdit'),
			},
			{
				path: '/agent-bank-info',
				name: 'agent-bank-info',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/agent/agentBankInfo'),
			},
			//Bank Info
			{
				path: '/bank-list',
				name: 'bank-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/bank/bankList'),
			},
			{
				path: '/bank-create',
				name: 'bank-create',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/bank/bankCreate'),
			},
			{
				path: '/bank-edit',
				name: 'bank-edit',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/bank/bankEdit'),
			},
			//Payment
			{
				path: '/deposit-list',
				name: 'deposit-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/payment/depositList'),
			},
			{
				path: '/withdraw-list',
				name: 'withdraw-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
					},
				component: () => import('../views/payment/withdrawList'),
			},
			// Member List
			{
				path: '/member-list',
				name: 'member-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/member/memberList'),
			},
			{
				path: '/agent-member-list',
				name: 'agent-member-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/member/agentMemberList'),
			},
			// Report
			{
				path: '/daily-report-list',
				name: 'daily-report-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/report/dailyList'),
			},
			{
				path: '/agent-report-list',
				name: 'agent-report-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/report/agentReportList'),
			},
			{
				path: '/member-report-list',
				name: 'member-report-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/report/memberReportList'),
			},
			{
				path: '/agent-daily-report-list',
				name: 'agent-daily-report-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/report/agentDailyList'),
			},
			{
				path: '/agent-member-report-list',
				name: 'agent-member-report-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/report/agentMemberReportList'),
			},
			{
				path: '/agent-request-withdraw-list',
				name: 'agent-request-withdraw-list',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/payment/agentRequestWithdrawList'),
			},
			{
				path: '/agent-request-withdraw-create',
				name: 'agent-request-withdraw-create',
				query: {
					page: 1,
					reverse: '',
					sort: '',
					name: ''
				},
				component: () => import('../views/payment/agentRequestWithdrawCreate'),
			},
		]
	},

	{
		path: '/*',
		redirect: '/dashboard'
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})


export default router
// Global navigation guard to prevent access to login page if authenticated
router.beforeEach((to, from, next) => {
	const token = localStorage.getItem('token');
	if (to.path === '/login' && token) {
		// If token exists, redirect to dashboard
		next('/dashboard');
	} else {
		next();
	}
});